import { ArrowsAltOutlined, EllipsisOutlined, ShrinkOutlined } from "@ant-design/icons";
import { Button, Card, Dropdown } from "antd";
import { useEffect, useState } from "react";

const CardChart = ({ index, title, items, setGraphModal, downloadExcel, onReset, extra, children }: any) => {
  //   if (index != 0)
  //     return null;
  const [zoomDiv, setzoomDiv] = useState<any>(false)






  const onClick: any = ({ key }: any) => {
    console.log(key,children)
    if (key.includes('view-users')) {
      setGraphModal(key)
    }
    else if (key.includes('export')) {
      downloadExcel(key)
    }
    else if (key == 'reset') {
      onReset();
    }
  };
  // console.log('children',children)

  return <>
    {zoomDiv && <div className="backdrop" onClick={() => setzoomDiv(false)} />}

    <Card className={"chart-card " + (zoomDiv ? 'zoomed' : '')} title={title} extra={
      <>
      {extra && <span style={{ marginRight: 10 }}>{extra}</span>}
        <Dropdown menu={{ items, onClick }} trigger={['click']}>
          <Button size="large" type="link"><EllipsisOutlined /> </Button>
        </Dropdown>
        <Button onClick={() => setzoomDiv((state: any) => !state)} size="large" type="link">
          {zoomDiv ? <ShrinkOutlined /> : <ArrowsAltOutlined />}
        </Button>
      </>


    }>
      <>
        {children}
      </>
    </Card>
  </>
}


export default CardChart;